import React, { useEffect, useState } from 'react';
import { login } from '../api/auth';
import { FRONTEND_VERSION, fetchBackendVersion } from '../api/version';
import { useAuthStore } from '../store/useAuthStore';
import { useCallStore } from '../store/useCallStore';
import { applyCompanyDefaults } from '../utils/applyCompanyDefaults';

export default function LoginPage() {
  const { login: storeLogin } = useAuthStore();
  const { setUserName } = useCallStore();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [backendVersion, setBackendVersion] = useState<string | null>(null);

  useEffect(() => {
    fetchBackendVersion()
      .then((v) => setBackendVersion(v.version))
      .catch(() => setBackendVersion(null));
  }, []);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!username || !password) return;
    setLoading(true);
    setError('');
    try {
      const { token, user, company } = await login(username, password);
      storeLogin(token, user, company);
      setUserName(user.displayName);
      applyCompanyDefaults(company);
    } catch {
      setError('Ungültige Anmeldedaten.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div
      className="min-vh-100 d-flex align-items-center justify-content-center"
      style={{ background: 'var(--bs-body-bg)' }}
    >
      <div className="card shadow border-0 rounded-4" style={{ width: '100%', maxWidth: 380 }}>
        <div className="card-body p-4">
          <div className="d-flex align-items-center gap-3 mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 16 16" fill="#0d6efd">
              <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58z" />
            </svg>
            <div>
              <h1 className="h5 mb-0 fw-bold text-primary">eves_MDR</h1>
              <p className="mb-0 small text-muted">Anmelden</p>
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label small fw-semibold" htmlFor="login-username">
                Benutzername
              </label>
              <input
                id="login-username"
                type="text"
                className="form-control"
                autoComplete="username"
                autoFocus
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                disabled={loading}
              />
            </div>
            <div className="mb-3">
              <label className="form-label small fw-semibold" htmlFor="login-password">
                Passwort
              </label>
              <input
                id="login-password"
                type="password"
                className="form-control"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading}
              />
            </div>
            {error && (
              <div className="alert alert-danger py-2 small mb-3">{error}</div>
            )}
            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={loading || !username || !password}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                  Anmelden…
                </>
              ) : (
                'Anmelden'
              )}
            </button>
          </form>

          <p className="text-center text-muted mb-0 mt-3" style={{ fontSize: '0.72rem' }}>
            Version {FRONTEND_VERSION}
            {backendVersion && backendVersion !== FRONTEND_VERSION && <> · Backend {backendVersion}</>}
          </p>
        </div>
      </div>
    </div>
  );
}
